<div [@slideInOut] class="mat-elevation-z24" tabindex="0" autofocus (keyup)="onkeydown($event)" (keydown)="onkeydown($event)" #container>
  @if (isTemplateRef(config.component)) {
    <ng-container *ngTemplateOutlet="config.component"></ng-container>
  } @else {
    <ng-container *ngComponentOutlet="config.component; injector: dataInjector"></ng-container>
  }
</div>
